import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from "@angular/forms";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {DateRangePickerPopoverV2Component} from "./date-range-picker-popover-v2.component";


@NgModule({
  declarations: [DateRangePickerPopoverV2Component],
  imports: [
    CommonModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
  ],
  exports: [DateRangePickerPopoverV2Component]
})
export class DateRangePickerPopoverV2Module {
}
